let _callback = null;

export function _registerToastCallback(fn) { _callback = fn; }

export function showToast(message, type = 'info') {
  if (_callback) _callback({ message, type });
}
